<template>
	<div v-visible="handleVisibilityChange" class="footer">
		<div class="footer_box">
			<div class="footer_box_one">
				<div class="footer_box_one_logo" @click="goIndex">
					<img :src="footData.site_bottom_logo" />
				</div>
				<div class="footer_box_one_right">
					<template v-for="(item, index) in social_media">
						<el-popover v-if="item.type == 2" placement="top" title="" width="114px" trigger="hover"
							content="">
							<img class="icon" :src="item.icon" slot="reference" />
							<img :src="item.url" style="width: 114px;height: 114px;" />
						</el-popover>
						<img @click="$openUrl(item.url)" class="icon" v-else :src="item.icon" alt="" />
					</template>
				</div>
			</div>
			<div class="footer_box_two">
				<div class="title">{{ footData.site_name }}</div>
				<div class="email">{{ footData.contact_email }}</div>
			</div>
			<div class="footer_box_threee">
				<div v-for="(item, index) in address" :key="index" class="addressItem">
					<div class="name">{{ item.country }}</div>
					<div class="text_detail">
						{{ item.address }}
					</div>
					<div class="text_detail">
						{{ item.phone }}
					</div>
				</div>
			</div>
			<div class="footer-bottom">
				<div class="record-item">{{ footData.fi_1 }}</div>
				<div class="footer-bottom-record">
					<div @click="urlClick(item)" :style="item.type == 1 || item.type == 2 ? 'cursor: pointer;' : ''"
						v-for="(item, index) in textList" :key="index" class="record-item">
						<img v-if="item.icon" class="textIcon" :src="item.icon" alt="" />
						<span>{{ item.content }}</span>
					</div>
				</div>
			</div>
		</div>

		<div v-show="showFixedBtn" class="pageFixed">
			<template v-for="(item, index) in social_media">
				<el-popover v-if="item.type == 2" placement="top" title="" width="114px" trigger="hover" content="">
					<div slot="reference" class="iconBox">
						<img class="icon" :src="item.icon" />
					</div>
					<img :src="item.url" style="width: 114px;height: 114px;" />
				</el-popover>
				<div @click="$openUrl(item.url)" v-else class="iconBox">
					<img class="icon" :src="item.icon" alt="" />
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import {
	get_config
} from "@/api/config.js"
export default {
	components: {

	},
	data() {
		return {
			showFixedBtn: false,
			social_media: [],
			address: [],
			textList: [],
			footData: {
				site_name: '',
				site_logo: '',
				site_bottom_logo: '',
				contact_email: '',
				fi_1: '',
			},
		}
	},
	created() {
		this.getConfigList();
		this.listenBtnShow()
	},
	mounted() {
		this.locale = this.$i18n.locale;
		console.log(this.$i18n.locale)

	},
	methods: {
		goIndex() {
			let t = this;
			var element;
			if (this.nowVibe == 'pc') {
				element = document.documentElement
			} else {
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
			if (t.$route.path == '/en' || t.$route.path == '/cn') {
				element.scrollTop = 0;
				return
			}
			if (t.$route.path != '/') {
				if (this.locale == 'zh') {
					t.$router.push('/cn')
				} else {
					t.$router.push('/en')
				}
			} else {
				element.scrollTop = 0;
			}
		},
		goPath(item) {
			let t = this;
			if (!item.path) {
				return
			}
			console.log(item.path)
			if (t.$route.path != item.path) {
				t.$router.push(item.path)
			}
		},
		getConfigList() {
			let data = {};
			get_config(data).then(res => {
				let config = res.data.config
				let contactTitle = config.find(el => el.code == 'contact_us').value
				let kefu_is_show = config.find(el => el.code == 'kefu_is_show')
				if (kefu_is_show.value == 1) {
					let title = config.find(el => el.code == 'kf_title').value
					let name = config.find(el => el.code == 'kf_name').value
					let btn_text = config.find(el => el.code == 'kf_btn_text').value
					let contact_us = config.find(el => el.code == 'kf_contact_us').value
					let kefu_jump_url = config.find(el => el.code == 'kefu_jump_url').value
					this.$bus.$emit('setServiceData', { title, name, btn_text, contact_us, kefu_jump_url })
				}
				this.$bus.$emit('setContactTitle', contactTitle)
				this.social_media = res.data.social_media
				this.address = res.data.address
				this.textList = res.data.text
				this.footData.site_name = config[0].value
				this.footData.site_logo = config[1].value
				this.footData.contact_email = config[3].value
				this.footData.site_bottom_logo = config[2].value
				this.footData.fi_1 = config[4].value
			}).catch(err => {
				console.log(err)
			})
		},
		goLink(e) {
			let t = this;
			let url = ''
			switch (e) {
				case 1: {
					url = t.config.in
					break;
				}
				case 2: {
					url = t.config.FaceBook
					break;
				}
				case 3: {
					url = t.config.twitter
					break;
				}
				case 4: {
					url = t.config.YouToBe
					break;
				}
			}
			window.open(url, '_blank')
		},
		listenBtnShow() {
			const path = this.$route.path
			if (path == '/' || path == '/en' || path == '/zh' || path == '/en/contact' || path == '/zh/contact') {
				this.showFixedBtn = true
			} else {
				this.showFixedBtn = false
			}
		},
		handleVisibilityChange(isVisible) {
			if (isVisible) {
				this.showFixedBtn = false
			} else {
				this.listenBtnShow()
			}
		},
		urlClick(data) {
			let { type, url } = data
			if (type == 1) {
				this.$openUrl(url)
			} else if (type == 2) {
				this.downloadFile(url)
			}
		},
		downloadFile(url) {
			const a = document.createElement('a')
			a.download = url
			a.href = url
			a.target = '_blank'
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		}
	}
}
</script>

<style>
.el-popover {
	min-width: auto !important;
}
</style>
<style scoped lang="scss">
.footer {
	width: 100%;
	background: #F7F7F7;

	.footer_box {
		width: 1200px;
		padding-top: 73px;
		padding-bottom: 42px;
		margin: 0 auto;

		.footer_box_one {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 26px;
			border-bottom: 0.2px dashed #9A9A9A;

			.footer_box_one_logo {
				img {
					width: 92px;
					height: 15px;
				}
			}

			.footer_box_one_right {
				display: inline-flex;

				.icon {
					width: 18px;
					height: 18px;
					margin-left: 13px;
					display: block;
					cursor: pointer;
				}
			}
		}

		.footer_box_two {
			margin-top: 36px;

			.title {
				font-size: 18px;
				color: #000000;
				line-height: 20px;
				font-weight: bold;
			}

			.email {
				margin-top: 14px;
				font-size: 18px;
				color: #9A9A9A;
				line-height: 20px;
			}
		}

		.footer_box_threee {
			margin-top: 45px;
			display: flex;
			flex-wrap: wrap;
			align-items: flex-start;
			padding-bottom: 50px;
			border-bottom: 1px solid #9A9A9A;

			.addressItem {
				width: 250px;
				margin-right: 110px;

				&:nth-child(4n) {
					margin-right: 0px;
				}

				.name {
					margin-bottom: 22px;
					font-size: 18px;
					color: #000000;
					line-height: 18px;
					font-weight: bold;
				}

				.text_detail {
					font-size: 14px;
					color: #9A9A9A;
					line-height: 24px;
				}
			}
		}

		.footer-bottom {
			padding-top: 20px;

			.record-item {
				font-size: 12px;
				color: #9A9A9A;
				line-height: 18px;
				margin-right: 49px;

				.textIcon {
					width: 18px;
					height: 18px;
					display: inline-block;
					vertical-align: top;
					margin-right: 5px;
				}

			}

			.footer-bottom-record {
				display: flex;
				margin-top: 11px;

				.record-item {
					font-size: 12px;
					color: #9A9A9A;

				}
			}
		}
	}
}

.pageFixed {
	position: fixed;
	right: calc((100vw - 1200px) / 4);
	transform: translate(50%, 0);
	bottom: 133px;
	z-index: 999;

	.iconBox {
		width: 33px;
		height: 33px;
		background: #E6E6E6;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 4px;
		cursor: pointer;

		.icon {
			width: 21px;
			height: 21px;
		}
	}
}

@media screen and (max-width:1200px) {
	.footer {
		.footer_box {
			width: 100%;
			padding-left: 20px;
			padding-right: 20px;
			box-sizing: border-box;

			.footer_box_threee {
				margin-top: 45px;
				display: flex;
				flex-wrap: wrap;
				gap: 30px;
				padding-bottom: 40px;

				.addressItem {
					width: calc((100% - 30px) / 2);
					margin-right: 0px;

					.name {
						margin-bottom: 22px;
						font-size: 18px;
						color: #000000;
						line-height: 18px;
						font-weight: bold;
					}

					.text_detail {
						font-size: 14px;
						color: #9A9A9A;
						line-height: 24px;
					}
				}
			}

			.footer-bottom {
				.record-item {
					margin-top: 15px;
				}

				.footer-bottom-record {
					display: block;
					margin-top: 11px;

					.record-item {
						font-size: 12px;
						color: #9A9A9A;
						margin-bottom: 15px;
					}
				}
			}
		}
	}

}
</style>